import { Chip } from "@/ui-kit";
import styles from "./VariantContainer.module.css";

type VariantSwitcherProps = {
  flagKey: string;
  variantKeys: string[];
  current: string;
  onPick: (variantKey: string) => void;
};

/**
 * Staff-mode control for previewing an A/B test: one chip per variant of the
 * container. The labels are the Amplitude flag and variant keys themselves, so
 * there is no copy to translate.
 */
export const VariantSwitcher = ({
  flagKey,
  variantKeys,
  current,
  onPick,
}: VariantSwitcherProps) => (
  <div className={styles.switcher} role="group" aria-label={flagKey}>
    <span className={styles.flagKey} aria-hidden>
      {flagKey}
    </span>
    {variantKeys.map((variantKey) => (
      <Chip
        key={variantKey}
        label={variantKey}
        selected={variantKey === current}
        onPress={() => onPick(variantKey)}
      />
    ))}
  </div>
);
